import * as ReactService from "@intech/react-service";
import { JsonWebToken } from "../entidades/JsonWebToken";
import { LoginEntidade } from "../entidades/LoginEntidade";

class Usuario extends ReactService.BaseService {
  constructor() {
    super("Usuario");
  }

  VerificarAdmin = () =>
    this.CreateRequest<boolean>(ReactService.RequestType.GET, `admin`);

  Login = (user: LoginEntidade) =>
    this.CreateRequest<JsonWebToken>(ReactService.RequestType.POST, `Login`, user);

  CriarAcesso = (user: LoginEntidade) =>
    this.CreateRequest<string>(ReactService.RequestType.POST, `CriarAcesso`, user);

  CriarAcessoV2 = (user: LoginEntidade, enviarEmail: boolean, enviarSms: boolean) =>
    this.CreateRequest<string>(ReactService.RequestType.POST, `CriarAcessoV2/${enviarEmail}/${enviarSms}`, user);

  CriarAcessoIntech = (data: LoginEntidade) =>
    this.CreateRequest<string>(ReactService.RequestType.POST, `criarAcessoIntech`, data);

  AlterarSenha = (user: LoginEntidade) =>
    this.CreateRequest<string>(ReactService.RequestType.POST, `AlterarSenha`, user);

  AlterarSenhaPrimeiroAcesso = (data: LoginEntidade) =>
    this.CreateRequest<string>(ReactService.RequestType.POST, `AlterarSenhaPrimeiroAcesso`, data);

  BuscarMatriculas = () =>
    this.CreateRequest<string[]>(ReactService.RequestType.GET, `BuscarMatriculas`);

  SelecionarParticipante = (login: LoginEntidade) =>
    this.CreateRequest<JsonWebToken>(ReactService.RequestType.POST, `SelecionarParticipante`, login);

  SelecionarMatricula = (matricula: string) =>
    this.CreateRequest<JsonWebToken>(ReactService.RequestType.POST, `SelecionarMatricula/${matricula}`);

  Menu = () =>
    this.CreateRequest<string[]>(ReactService.RequestType.GET, `Menu`);

}

export const UsuarioService = new Usuario();
